import { render, staticRenderFns } from "./AddTrackingInfo.vue?vue&type=template&id=128e4715"
import script from "./AddTrackingInfo.vue?vue&type=script&lang=js"
export * from "./AddTrackingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports